import React, { useRef, useState } from "react";

import SectionTitle from "@app/components/3_modules/sections/SectionTitle";
import { Calculator, ChevronUp, ChevronDown } from "lucide-react";
import AddedValue from "@app/components/2_widgets/dossiers/AddedValue";
import { useDossier, useDossierDispatch, DOSSIER_ACTIONS } from "@app/contexts/DossierContext";
import Badge from "@app/components/1_elements/Badge";
import ElectricConsumption from "@app/components/2_widgets/dossiers/ElectricConsumption";
import ElectroEligibility from "@app/components/2_widgets/dossiers/ElectroEligibility";
import { useAuth } from '@app/contexts/AuthContext';
import { apiCall } from '@app/utils/apiCall';
import { useToast } from '@app/components/3_modules/ToastContainer';

import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";

export default function SectionAddedValue() {
    const [displaying, setDisplaying] = useState(false);

    const dossier = useDossier();
    const dossierDispatch = useDossierDispatch();
    const toast = useToast();
    
    const auth = useAuth();

    function displayContent() {
        if (!displaying)
            return;        

        return (
            <div>
                <AddedValue />
                <ElectricConsumption />
                <ElectroEligibility />
                <div className="text-end">
                    <ButtonPrimary label="Valider la Valeur Ajoutée" onClick={validateAddedValue}/>
                </div>                
            </div>            
        )        
    }

    function validateAddedValue() {
        const formData = new FormData();
        formData.append("dossier[status]", "validated_added_value"),

        apiCall({
            method: "patch",
            path: `/api/v1/dossiers/${dossier.id}`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                dossierDispatch({
                    type: DOSSIER_ACTIONS.UPDATE_ALL,
                    payload: response.data.dossier
                });                    
                toast.addToast("La Valeur Ajoutée a été validée")
            }
        });
    }

    const badgeStatus = dossier.validated_added_value ? "validated" : "in_progress";
    const badgeLabel = dossier.validated_added_value ? "Terminé" : "À compléter";
        
    return (
        <div className="page-section">
            <SectionTitle
                icon={<Calculator />}
                title="Valeur Ajoutée"
                onClick={() => setDisplaying(!displaying)}
                rightIcon={displaying ? <ChevronUp /> : <ChevronDown />}
                badge={<Badge label={badgeLabel} classProp={`badge-${badgeStatus}`} />}
            />
            {displayContent()}            
        </div>
    )
}